export * from "-!../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./index.vue?vue&type=template&id=6884f154&scoped=true"


//////////////////
// WEBPACK FOOTER
// ./src/components/clients/client/messages/index.vue?vue&type=template&id=6884f154&scoped=true
// module id = oOFv
// module chunks = 0